import {
    apiRequest,
    salaryP3KCreate,
    pangkatP3KList
} from "../../../../../services/adapters/master/salaryP3KService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", salaryP3KCreate, {
            body: query
        }, true)
    }

    fetchRank = async (query) => {
        return await apiRequest("get", pangkatP3KList, {
            params: query
        }, true)
    }
}

export default CreateRepository